var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTechparkwhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;}.cls-1{stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.38,32.8v-17S57.1-9.28,91,14.31V32.8S64.53,7.75,29.38,32.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1.94,
    y: 110.36,
    width: 116.55,
    height: 3.83
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "29.38 32.8 29.38 110.16 91.04 110.16 91.04 32.8 114.94 32.8 114.94 111.42"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.22,
    y1: 28.48,
    x2: 36.22,
    y2: 110.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 44.69,
    y1: 24.61,
    x2: 45.45,
    y2: 110.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 84.56,
    y1: 28.48,
    x2: 84.56,
    y2: 110.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.09,
    y1: 24.61,
    x2: 75.33,
    y2: 110.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.94,55.42c-12.92,10.34-23.9,0-23.9,0-35.55-19.21-61.66,0-61.66,0s-12.93,13.28-23.9,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.94,76C102.56,82.88,91,76,91,76c-35.55-19.22-61.66,0-61.66,0S14.86,86.45,5.48,76"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 45.45,
    y1: 79.99,
    x2: 75.33,
    y2: 79.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 60.21,
    y1: 79.99,
    x2: 60.39,
    y2: 110.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 91.04,
    y1: 82.47,
    x2: 114.94,
    y2: 82.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.48,
    y1: 83.44,
    x2: 29.38,
    y2: 83.44
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "91.04 24.61 118.49 24.61 118.49 32.8 114.94 32.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "29.38 22.3 1.94 22.3 1.94 30.49 5.48 30.49 29.38 30.49"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.48,
    y1: 30.49,
    x2: 5.48,
    y2: 111.42
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechparkwhite);
export default __webpack_public_path__ + "static/media/techparkwhite.cc5ba2cf39a9321ff0681dc2c00dbed8.svg";
export { ForwardRef as ReactComponent };